var _rect, _rect2, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForesightCardThumbnail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 500",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    fill: "#F5F2E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 118,
    width: 72,
    height: 4,
    fill: "#16A34A"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 96,
    fontSize: 17,
    letterSpacing: "0.14em",
    fontWeight: 600,
    fill: "#6B7F74"
  }, "FUTURES")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 292,
    fontSize: 56,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Thirty Sources,")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 362,
    fontSize: 56,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "One Thinking Partner")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForesightCardThumbnail);
export default __webpack_public_path__ + "static/media/foresight-card-thumbnail.203cf9b07a26e3fa2512089ee81eba6a.svg";
export { ForwardRef as ReactComponent };